export default class Pager {
  pageIndex?: any = 1
  pageSize?: any = 10
  itemCount?: any = 0
  pageCount?: any = 1
}